module.exports = __webpack_public_path__ + "img/64228751e18d78cfec9ce53c4dd9928d.png";